import Main from "./novelty/main.es6";

const main = new Main();